import React from 'react';

/** 
 * Context to locale and tenantId in registration workflow
 */
const TenantContext = React.createContext();

export default TenantContext;
